import {financeAPI} from "../../axios";

export const actions = {
    createAccounts(context, data)
    {
        return financeAPI.post("Accounts/CreateAccount", data);
    },
    getSingleAccount(context, data){
        return financeAPI.get(`Accounts/${data}`);
    },
    updateAccount(context, {id, data}){
        return financeAPI.put(`Accounts/${id}`, data);
    },
    deleteAccount(context, data){
        return financeAPI.delete(`Accounts/${data}`);
    },
    getAccountByAccountGroup(context, data)
    {
        return financeAPI.get(`Accounts/AccountGroup/${data}`);
    },
    getAllAccounts(){
        return financeAPI.get("Accounts/All");
    },
    getAccountsForDisbursement(context){
        return financeAPI.get("Accounts/Disbursement");
    },
    getAccountsForExpense(context){
        return financeAPI.get("Accounts/Expense");
    }
}